var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewRouteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 12.8332C10.721 12.8332 13.3327 10.2215 13.3327 6.99984C13.3327 3.77818 10.721 1.1665 7.49935 1.1665C4.27769 1.1665 1.66602 3.77818 1.66602 6.99984C1.66602 10.2215 4.27769 12.8332 7.49935 12.8332Z",
    stroke: "#FF833C",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49946 6.26995C7.07263 6.26995 6.20164 5.32793 6.20164 5.32793M7.49946 6.26995C7.92621 6.26995 8.79716 5.32789 8.79716 5.32789M7.49946 6.26995L7.49942 3.28769M7.49942 7.73273C7.07263 7.73269 6.20162 8.67472 6.20162 8.67472M7.49942 7.73273C7.92617 7.73273 8.79716 8.67475 8.79716 8.67475M7.49942 7.73273V10.7123",
    stroke: "#FF833C",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRouteCircle);
export default __webpack_public_path__ + "static/media/view-route-circle.df558183d477d65e808180e2a3996038.svg";
export { ForwardRef as ReactComponent };